import * as api from './api';
import { SaleRateIndexingRule } from './models';
import * as MutationTypes from './mutationTypes';

export const saleRateIndexingRuleListRequest = async ({ commit, getters: { saleRateIndexingRuleList } }, pointOfSaleGuid) => {
  if (saleRateIndexingRuleList.length === 0) {
    const response = await api.saleRateIndexingRuleListRequest(pointOfSaleGuid);
    const rules = SaleRateIndexingRule.toInstanceList(response.data.results);
    commit(MutationTypes.SALE_RATE_INDEXING_RULE_LIST_SUCCESS, rules);
  }
};

export const createSaleRateIndexingRuleRequest = async ({ commit }, ruleToCreate) => {
  const response = await api.createSaleRateIndexingRuleRequest(ruleToCreate.serialize());
  const ruleCreated = SaleRateIndexingRule.toInstance(response.data);
  commit(MutationTypes.CREATE_SALE_RATE_INDEXING_RULE_SUCCESS, ruleCreated);
};

export const updateSaleRateIndexingRuleRequest = async ({ commit }, ruleToUpdate) => {
  await api.updateSaleRateIndexingRuleRequest(ruleToUpdate.serialize());
  commit(MutationTypes.UPDATE_SALE_RATE_INDEXING_RULE_SUCCESS, ruleToUpdate);
};

export const removeSaleRateIndexingRuleRequest = async ({ commit }, ruleGuidToDelete) => {
  await api.removeSaleRateIndexingRuleRequest(ruleGuidToDelete);
  commit(MutationTypes.REMOVE_SALE_RATE_INDEXING_RULE_SUCCESS, ruleGuidToDelete);
};
